module.exports = __webpack_public_path__ + "static/img/doctor-strange.b07ece5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posters/doctor-strange.jpg
// module id = R1sF
// module chunks = 0